import {Auth0Lock, Auth0LockPasswordless} from 'auth0-lock'
//import Auth0LockPasswordless from 'auth0-lock-passwordless';
import config from './../config'
import { client } from '../index'

import { gql } from 'react-apollo'

const host = window.location.host
const protocol = window.location.protocol
const _lock = new Auth0Lock(config.authClientId, config.authDomain, {
  auth: {
    responseType: 'token id_token',
    redirectUrl: protocol + '//' + host + config.authRedirect,
    params: {
      scope: 'openid email create:users update:users'
    }
  },
  rememberLastLogin: false
})

const _passwordlesslock = new Auth0LockPasswordless(config.authClientId, config.authDomain, {
  auth: {
    responseType: 'token id_token',
    redirectUrl: protocol + '//' + host + config.authRedirect,
    params: {
      scope: 'openid profile email picture'
    }
  },
  closable: false,
  rememberLastLogin: false,
  passwordlessMethod: 'code',
  allowedConnections: ['sms']
})

export function showPasswordlessLogin() {
  _passwordlesslock.show()
}


export function showLogin() {
  _lock.show({
    initialScreen: 'login'
  })
}

export function showSignup(authRedirect) {
  if (authRedirect) {
    window.localStorage.setItem('authRedirect', authRedirect)
  }
  _lock.show({
    initialScreen: 'signUp'
  })
}

const getApiToken = async () => {
  try {
    let response = await fetch(config.tokenAPI, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        grant_type: 'client_credentials',
        client_id: config.authAPIClientId,
        client_secret: config.authAPIClientSecret,
        audience: config.authApiUrl
      })
    })

    let body = await response.json();
    window.localStorage.setItem('accessToken', body.access_token)
    return body.access_token
  }
  catch (err) {
    console.error(err)
  }
}

export const getLogs = () => {
  const userId = window.localStorage.getItem('user_id')
  const apiToken = window.localStorage.getItem('accessToken')
  return fetch(config.passwordAPI + `${userId}/logs?q=s&sort=type%3A1&page=0&per_page=30`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${apiToken}`
    }
  })
}

export const changePassword = pass => {
  const userId = window.localStorage.getItem('user_id')
  const apiToken = window.localStorage.getItem('accessToken')
  return fetch(config.passwordAPI + `${userId}`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${apiToken}`
    },
    body: JSON.stringify({
      password: pass,
      connection: 'Username-Password-Authentication'
    })
  })
} 

const patchUser = async (userId, bodyData) => {
  const apiToken = window.localStorage.getItem('accessToken')
  try {
    let response = await fetch(config.passwordAPI + `${userId}`, {
      method: 'PATCH',
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      },
      body: JSON.stringify(bodyData)
    })
    return (response.status == 200)
  }
  catch(err) {
    console.error(err)
  }
  return false
}


export const changeAuthDetails = async (userId, email, phone) => {
  // Extract from user id the actual value - starts after 'auth0|...'
  let connection = 'Username-Password-Authentication'
  if (userId.startsWith('facebook')) {
    connection = 'facebook'
  } 
  let bodyData = {user_metadata: { "name": phone }}
  if (userId.startsWith('auth0')) {
    bodyData.email = email
    bodyData.connection = connection
    bodyData.client_id = config.authClientId
  }
  patchUser(userId, bodyData)
  .then(async function(patchResponse) {
    if (!patchResponse) {
      // Retry but get token again
      await getApiToken()
      patchUser(userId, bodyData)
    }
  })
  .catch(async function(err) {
      // Retry but get token again
      await getApiToken()
      patchUser(userId, bodyData)    
  })
}

/*
  export function requireAuth(nextState, replace) {
    if (!isLoggedIn()) {
      replace({pathname: '/'});
    }
  }

  export function getIdToken() {
    return localStorage.getItem(ID_TOKEN_KEY);
  }

  export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  function clearIdToken() {
    localStorage.removeItem(ID_TOKEN_KEY);
  }

  function clearAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }

  function getTokenExpirationDate(encodedToken) {
    const token = decode(encodedToken);
    if (!token.exp) { return null; }

    const date = new Date(0);
    date.setUTCSeconds(token.exp);

    return date;
  }

  function isTokenExpired(token) {
    const expirationDate = getTokenExpirationDate(token);
    return expirationDate < new Date();
  }

  export function isLoggedIn() {
    const idToken = getIdToken();
    return !!idToken && !isTokenExpired(idToken);
  }

  */

export function setAuthenticationHandler(handler) {
  var theLock = _lock
  theLock.on('authenticated', authResult => {
    window.localStorage.setItem('auth0IdToken', authResult.idToken)
    theLock.getUserInfo(authResult.accessToken, (error, profile) => {
      getApiToken()
      window.localStorage.setItem('user_id', profile.sub)

      client.mutate({
        mutation: loggedInUserMutation,
        fetchPolicy: 'no-cache',
        variables: {
          id: profile.sub,
          token: authResult.idToken
        }
      })
      .then(result => {          
          let authUrlRedirect = window.localStorage.getItem('authRedirect')
          handler(profile, authUrlRedirect)
          window.localStorage.removeItem('authRedirect')
      })
    })
  })
  theLock.on('hide', authResult => {
    window.localStorage.removeItem('authRedirect')
  })
  theLock = _passwordlesslock
  theLock.on('authenticated', authResult => {
    window.localStorage.setItem('auth0IdToken', authResult.idToken)
    theLock.getUserInfo(authResult.accessToken, (error, profile) => {
      getApiToken()
      window.localStorage.setItem('user_id', profile.sub)
      let authUrlRedirect = window.localStorage.getItem('authRedirect')
      handler(profile, authUrlRedirect)
      window.localStorage.removeItem('authRedirect')
    })
  })
  theLock.on('hide', authResult => {
    window.localStorage.removeItem('authRedirect')
  })
}

const loggedInUserMutation = gql`
mutation loggedInUserMutation($id: bpchar!, $token: bpchar!) {
  insert_loggedInUser(objects: {id: $id, token: $token},
    on_conflict: {
      constraint: loggedInUser_pkey,
      update_columns: token
    }) {
    returning {
      id
      token
    }
  }
}
`;



// WEBPACK FOOTER //
// src/libs/authService.js